
import { TrendingUp } from "lucide-react";

const DashboardLoading = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-emerald-50 flex items-center justify-center">
      <div className="text-center">
        <TrendingUp className="w-12 h-12 text-slate-400 mx-auto mb-4 animate-pulse" />
        <p className="text-slate-600">جاري تحميل لوحة التحكم...</p>
      </div>
    </div>
  );
};

export default DashboardLoading;
